/**
 * Created by shinan.chen on 2021/12/25.
 */
import { getCommon, postCommon } from '../tools';
import * as config from '../config';
import { ITeacher } from './teacher';

export interface ITeachClass {
    id: number,
    name: string,
    teacherId: number,
    storeId: number,
    teacherName: string,
    remark: string,
    studentCount: number,
    courseCount: number,
    courseFinishount: number,
    enable: boolean,

    storeName: string,
}


export interface ITeachClassStudent {
    id: number,
    studentIds: number[],
    teachClassId: number,
}

export interface ITeachClassCourse {
    id: number,
    teachClassId: number,
    teacherId: number,
    classroomId: number,
    courseDefinitionId: number,
    planStartTime: Date,
    planStartTimeName: string,
    costValue: number,
    costHour: number,
    remark: string,
    status: string,

    teacherName: string,
    courseDefinitionName: string,
    teachClassName: string,
    studentCount: number,
    punchRecordCount: number,
    classroomName: string,
    classroomColor: string,
}

export const listTeachClasss = () =>
    getCommon({
        url: `${config.SERVICE_URL}/teach_class/list_all`,
    });

export const createTeachClass = (data: ITeachClass) =>
    postCommon({
        url: `${config.SERVICE_URL}/teach_class/create`,
        data
    });

export const updateTeachClass = (data: ITeachClass) =>
    postCommon({
        url: `${config.SERVICE_URL}/teach_class/update`,
        data
    });

export const deleteTeachClass = (id: number) =>
    postCommon({
        url: `${config.SERVICE_URL}/teach_class/delete?id=${id}`
    });

export const enableTeachClass = (id: number, enable: boolean) =>
    postCommon({
        url: `${config.SERVICE_URL}/teach_class/enable?id=${id}&&enable=${enable}`
    });

export const pageTeachClasss = (pageNum: number, pageSize: number, filterStoreIds:any, keyword: string) =>
    getCommon({
        url: `${config.SERVICE_URL}/teach_class/page?pageNum=${pageNum}&&pageSize=${pageSize}&&storeIds=${filterStoreIds}&&keyword=` + encodeURI(keyword),
    });

export const listTeachClassStudents = (teachClassId: any) =>
    getCommon({
        url: `${config.SERVICE_URL}/teach_class/student/list_all?teachClassId=${teachClassId}`,
    });

export const createTeachClassStudent = (data: ITeachClassStudent) =>
    postCommon({
        url: `${config.SERVICE_URL}/teach_class/student/create`,
        data
    });

export const deleteTeachClassStudent = (studentId: number, teachClassId: number) =>
    postCommon({
        url: `${config.SERVICE_URL}/teach_class/student/delete?studentId=${studentId}&&teachClassId=${teachClassId}`
    });

export const listTeachClassCourses = (teachClassId: any) =>
    getCommon({
        url: `${config.SERVICE_URL}/teach_class/course/list_all?teachClassId=${teachClassId}`,
    });

export const createTeachClassCourse = (data: ITeachClassCourse) =>
    postCommon({
        url: `${config.SERVICE_URL}/teach_class/course/create`,
        data
    });

export const updateTeachClassCourse = (data: ITeachClassCourse) =>
    postCommon({
        url: `${config.SERVICE_URL}/teach_class/course/update`,
        data
    });

export const updateStatusTeachClassCourse = (teachClassId: number, id: number, status: string, remark: any, notice: any, noticeRemark:any) =>
    postCommon({
        url: `${config.SERVICE_URL}/teach_class/course/update_status?teachClassId=${teachClassId}&id=${id}&status=${status}` + (remark ? `&remark=${remark}` : ``) + (notice ? `&notice=${notice}` : ``) + (noticeRemark ? `&noticeRemark=${noticeRemark}` : ``)
    });

export const deleteTeachClassCourse = (teachClassCourseId: number, teachClassId: number) =>
    postCommon({
        url: `${config.SERVICE_URL}/teach_class/course/delete?id=${teachClassCourseId}&teachClassId=${teachClassId}`
    });

export interface IScheduleView {
    columns: IScheduleColumn[],
    times: IScheduleTime[],
    cellMap: ICellMap,
}

export interface ICellMap {
    [key: string]: ITeachClassCourse[]
}

export interface IScheduleTime {
    timeCode: string,
    timeName: string,
}

export interface IScheduleColumn {
    title: string,
    dataIndex: string,
    key: string,
    width: string,
}

export const courseSchedule = (weekIndex: number,findDate: string, storeIds: any, modeType: string) =>
    getCommon({
        url: `${config.SERVICE_URL}/teach_class/course/schedule?weekIndex=${weekIndex}&&storeIds=${storeIds}&&modeType=${modeType}&&findDate=` + encodeURI(findDate),
    });

export interface ITeachClassCourseDetail {
    id: number,
    teachClassId: number,
    teacherId: number,
    classroomId: number,
    courseDefinitionId: number,
    planStartTime: Date,
    remark: string,
    finish: boolean,
    teacherName: string,
    courseDefinitionName: string,
    courseStudents: ITeachClassCourseStudent[],
}

export interface ITeachClassCourseStudent {
    id: number,
    name: string,
    punchRecord: boolean,
}

export const getCourseDetail = (teachClassCourseId: any) =>
    getCommon({
        url: `${config.SERVICE_URL}/teach_class/course/get_detail?teachClassCourseId=${teachClassCourseId}`,
    });

export interface ITeachClassCourseFinish {
    id: number,
    teacherId: number,
    classroomId: number,
    courseDefinitionId: number,
    planStartTime: Date,
    remark: string,
    priorityConsumeCardId: number,
    punchRecordStudentIds: number[],
}

export const finishCourse = (data: ITeachClassCourseFinish) =>
    postCommon({
        url: `${config.SERVICE_URL}/teach_class/course/finish`,
        data
    });

export interface IDataView {
    teachers:ITeacherData[],
    totalTeachClassCount:number,
    totalStudentCount:number,
    totalCourseHourCount:number,
    totalPunchRecordCount:number,
    totalCourseCostMoney:string,
    totalInvalidCostMoney:string,
    totalExtraCostMoney:string,
    totalCostMoney:string,
}

export interface ITeacherData {
    id:number,
    name:string,
    teachClassCount:number,
    studentCount:number,
    courseHourCount:number,
    punchRecordCount:number,
    courseCostMoney:string,
    teachClasss:ITeachClassData[],
}

export interface ITeachClassData {
    name:string,
    studentCount:number,
    message:string,
    storeName:string,
    teachClassCourses:ITeachClassCourseData[],
}
export interface ITeachClassCourseData {
    message:string,
}

export const getDataView = (startDate:any,endDate:any,storeId:any) =>
    getCommon({
        url: `${config.SERVICE_URL}/teach_class/data?`+(startDate ? `&startDate=${startDate}` : ``)+(endDate ? `&endDate=${endDate}` : ``)+(storeId ? `&storeId=${storeId}` : ``),
    });